import { gql } from "@apollo/client";

export const GET_BUSINESS_CATEGORIES = gql`
  query GetbusinessCategories {
    getBusinessCategories {
      id
      name
      businesses {
        name
        countryId
        displayOnBookingPage
        businessBookingTypes {
          displayOnBookingPage
        }
      }
    }
  }
`;
